// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.STtBzJOrko1dRDAD6_r3 {
  margin: 0 auto;
  width: 100%;
  max-width: 570px;
}

@media (max-width: 575.98px) {
  .STtBzJOrko1dRDAD6_r3 {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Container/style.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".container {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 570px;\n}\n\n@media (max-width: 575.98px) {\n  .container {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `STtBzJOrko1dRDAD6_r3`
};
export default ___CSS_LOADER_EXPORT___;
